import { i18n } from '@/i18n'
import taxes from '@/store/modules/invoicesIssuing/step4LineTaxes'
import products from '@/store/modules/invoicesIssuing/step4LineProducts'
import parent from '@/store/interfaces/tableViewGeneric'


const getTranslateMasterFilters = function () {
  return {
    codProducto: { label: i18n.t('invoices.invoices_issuing.cod_producto'), value: '' },
    descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
    cantidadMax: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_max'), value: '', type: 'number' },
    cantidadMin: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_min'), value: '', type: 'number' },
    precioUnitarioMax: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_max'), value: '', type: 'number' },
    precioUnitarioMin: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_min'), value: '', type: 'number' },
    totalMax: { label: i18n.t('invoices.invoices_issuing.step4.total_max'), value: '', type: 'number' },
    totalMin: { label: i18n.t('invoices.invoices_issuing.step4.total_min'), value: '', type: 'number' },
    descuento: { label: i18n.t('invoices.invoices_issuing.descuento'), value: '', type: 'number' },
    cuota: { label: i18n.t('invoices.invoices_issuing.discount_cuota'), value: '', type: 'number' },
    additionalLineItemInformation: { label: i18n.t('invoices.invoices_issuing.observaciones'), value: '' },
  } 
}
const getTranslateColumns = () => [
  // {
  //   field: ' ',
  //   title: '',
  //   width: '100px',
  //   headerCell: (h) => h('span'),
  //   cell: 'actionsTemplate',
  //   locked: true,
  //   lockable: false,
  //   columnMenu: false,
  //   reorderable: false,
  //   filterable: false,
  //   resizable: false,
  //   groupable: false,
  //   only: { empty: false },
  //   extraparams: {
  //     // actionId: 'idAccion',
  //     // actionIcon: 'icon',
  //     actions: [
  //       { idAccion: 2, label: i18n.t('app.edit'), icon: 'editpencil' },
  //       { idAccion: 3, label: i18n.t('app.remove'), icon: 'trash' }
  //     ]
  //   } 
  // },
  // { field: 'uuid', title: 'UUID', columnMenu: 'myTemplate', width: '300px', editable: false, locked: false, hidden: true, sortable: false, only: { roles: [3] } },
  { field: 'lineNumber', title: i18n.t('invoices.invoices_issuing.linea'), cell: 'numberTemplate', format: 'integer', columnMenu: 'myTemplate', width: '90px', editable: false, filterable: false, groupable: false, hidden: false, expandable: true },
  { field: 'idProducto', width: '100px', title: i18n.t('app.id'), columnMenu: 'myTemplate', hidden: true, editable: false, locked: false },
  { field: 'codProducto', title: i18n.t('invoices.invoices_issuing.cod_producto'), columnMenu: 'myTemplate', width: '195px', editable: false, locked: false, hidden: true },
  { field: 'descripcion', title: i18n.t('invoices.invoices_issuing.descripcion'), columnMenu: 'myTemplate', width: '180px', editable: false, locked: false },
  { field: 'UnitPriceWithoutTax', title: i18n.t('invoices.invoices_issuing.precio_unitario'), cell: 'numberTemplate', format: 'currency', columnMenu: 'myTemplate', width: '160px', editable: true, locked: false },
  { field: 'cantidad', title: i18n.t('invoices.invoices_issuing.step4.cantidad'), cell: 'numberTemplate', format: 'decimal', columnMenu: 'myTemplate', width: '120px', editable: true, locked: false },
  { field: 'descuentos.0.descuento', title: i18n.t('invoices.invoices_issuing.descuento_short'), editable: false, cell: 'numberTemplate', format: 'percent_decimal', columnMenu: 'myTemplate', width: '110px', locked: false },
  { field: 'taxes.0.cuota', title: i18n.t('invoices.invoices_issuing.tax_cuota'), editable: false, cell: 'numberTemplate', format: 'currency_8', columnMenu: 'myTemplate', width: '170px', locked: false },
  { field: 'totalConImpuesto', title: i18n.t('app.total'), cell: 'numberTemplate', format: 'currency_8', columnMenu: 'myTemplate', width: '120px', editable: false, locked: false },
  { field: 'additionalLineItemInformation', title: i18n.t('invoices.invoices_issuing.observaciones'), columnMenu: 'myTemplate', width: '200px', editable: false, locked: false },
]
const getDefaultForm = () => ({
  tipoImpuesto: '',
  tipoAsociado: '',
  fechaAplicacion: '',
  invoiceLines: [],
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const customState = getDefaultState()
const customGetters = { form: state => state.form }
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  },
}
const mystore = parent({ getTranslateColumns, customState, customGetters, customActions, navigate: false, editable: 'row', namespaced: true, selectable: true, expandable: 'auto', modules: { taxes, products }, getTranslateMasterFilters })

export default mystore
